<div class="view-status">
    <div *ngIf="returnCode === -1">
        <div class="table">
            <div class="table-row app-loader-blink" style="padding: 2rem"></div>
            <div class="table-row app-loader-blink" *ngFor="let i of arr"></div>
        </div>
    </div>

    <div *ngIf="returnCode === 9" class="details-not-found">
        <div class="wrapper">
            <img src="/assets/images/transaction-details/detail-not-found.svg" class="no-details-img" />
            <span class="title">אי אפשר להציג עסקות כרגע</span>
            <span>כדאי לנסות שוב מאוחר יותר.</span>
        </div>
    </div>

    <div *ngIf="returnCode === 10" class="no-deals">
        <img src="/assets/images/transaction-details/empty-state-img.svg" class="empty-state-pic" />
        <span class="no-deald-text">לא קיימות הוראת קבע</span>
    </div>
</div>
